export default "__VITE_ASSET__BTv$ceY3__"